import { Bell } from 'lucide-react';
import {
    Popover,
    List,
    ListItem,
    ListItemText,
    Typography,
    Badge,
    IconButton,
    Divider,
    Box,
} from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import { io } from "socket.io-client";
import { SOCKET_URL } from '../../../config';
import { useGetNotification } from '../../notification/api/apiNotification';
import { useToast } from '../../../hooks/usetoast';
import { useNavigate } from 'react-router-dom';


export default function UserExportButton() {

    const { data: getNotifications, refetch } = useGetNotification({

        page: 0,
        size: 5,
        searchText: '',

    });
    const toast = useToast()
    let notifications = getNotifications?.data?.data || []
    const [anchorEl, setAnchorEl] = useState(null);
    const [notifiCount, setNotifiCount] = useState(0);

    const buttonRef = useRef(null);

    const unreadCount = getNotifications?.data?.count

    const navigate = useNavigate()
    useEffect(() => {


        const newSocket = io(SOCKET_URL,
            {
                transports: ["polling"],
                polling: 10000,
            }
        )

        newSocket.on("adminNotify", (message) => {
            if (message) {
                setNotifiCount(Number(message?.count))
                refetch();
            }
        });

        return () => { newSocket.disconnect(); };

    }, [])



    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMarkAllAsRead = () => {


        try {

            const newSocket = io(SOCKET_URL)
            newSocket.emit('markAllRead', {}, (response) => {

                refetch();

                newSocket.close();
            });

        } catch (error) {
            console.log("error: ", error);

        }

        handleClose();
    };

    const handleNotificationClick = (_id) => {

        try {
            const newSocket = io(SOCKET_URL)

            newSocket.emit('markRead', { _id }, (response) => {


                toast.success("Notification marked as read");
                refetch();


                newSocket.close();
            });

        } catch (error) {
            console.log("error: ", error);

        }
    };

    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    return (
        <>

            <IconButton
                ref={buttonRef}
                onClick={handleClick}
                aria-describedby={id}
                sx={{
                    position: 'relative',
                    color: '#9ad32fff',
                    transition: 'all 0.2s ease',

                }}
            >
                <Badge badgeContent={notifiCount || unreadCount} color="error" max={99}>
                    <Bell size={25} />
                </Badge>
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            width: 360,
                            maxHeight: 400,
                            mt: 1,
                            borderRadius: 2.5,
                            boxShadow: '0px 10px 30px rgba(0,0,0,0.12)',
                            overflow: 'hidden',
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        p: 2,
                        pb: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        bgcolor: notifiCount > 0 ? '#fffaf7' : '#f9f9f9',
                    }}
                >
                    <Typography variant="h6" fontWeight={600} color="text.primary">
                        Notifications
                    </Typography>

                    {unreadCount > 0 && (
                        <Box
                            onClick={handleMarkAllAsRead}
                            sx={{
                                px: 1.5,
                                py: 0.7,
                                borderRadius: 100,
                                bgcolor: '#e8f5e9',
                                color: '#2e7d32',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                border: '1px solid #c8e6c9',
                                '&:hover': {
                                    bgcolor: '#c8e6c9',
                                    transform: 'scale(1.03)',
                                },
                                transition: 'all 0.2s ease',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                            }}
                        >
                            Mark All Read
                        </Box>
                    )}
                </Box>

                <List sx={{ py: 0, maxHeight: 280, overflowY: 'auto' }}>
                    {notifications.length === 0 ? (
                        <ListItem>
                            <ListItemText
                                primary="No notifications"
                                primaryTypographyProps={{ align: 'center', color: 'text.secondary', height: '200px', alignContent: "center" }}
                            />
                        </ListItem>
                    ) : (
                        notifications.map((notif) => (
                            <div key={notif._id}>
                                <ListItem
                                    sx={{
                                        px: 2,
                                        py: 1.5,
                                        bgcolor: notif?.readStatus ? 'transparent' : 'action.hover',
                                        cursor: 'pointer',
                                        '&:hover': {
                                            bgcolor: 'action.selected',
                                        },
                                        transition: 'background-color 0.2s ease',
                                    }}
                                    onClick={() => handleNotificationClick(notif._id)}
                                >
                                    <ListItemText
                                        primary={
                                            <Typography
                                                variant="body2"
                                                fontWeight={notif?.readStatus ? 400 : 600}
                                                color={notif?.readStatus ? 'textSecondary' : 'textPrimary'}
                                            >
                                                {notif.notifyType}
                                            </Typography>
                                        }
                                        secondary={

                                            <Typography
                                                component="div"
                                                variant="body2"
                                                color="textSecondary"
                                                sx={{ lineHeight: 1.4, mb: 0.5 }}
                                            >
                                                {notif.notifyMessage}
                                            </Typography>


                                        }
                                    />
                                </ListItem>
                                <Divider component="li" />
                            </div>
                        ))
                    )}
                </List>

                <Box
                    sx={{
                        p: 2,
                        pt: 1,
                        textAlign: 'center',
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        bgcolor: '#fafafa',
                    }}
                >
                    <Box
                        onClick={() => {
                            navigate('/notification')
                            handleClose();
                        }}
                        sx={{
                            px: 2,
                            py: 0.8,
                            borderRadius: 1.5,
                            bgcolor: '#e3f2fd',
                            color: '#1565c0',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0.7,
                            border: '1px solid #bbdefb',
                            '&:hover': {
                                bgcolor: '#bbdefb',
                                transform: 'translateY(-1px)',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                            },
                            transition: 'all 0.2s ease',
                        }}
                    >
                        View All Notifications
                    </Box>
                </Box>

            </Popover>
        </>
    );
}